import script from "./MainSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSection.vue?vue&type=script&setup=true&lang=js"

import "./MainSection.vue?vue&type=style&index=0&id=32fa7705&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32fa7705"]])

export default __exports__